// import React from "react"
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { Link, useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import authAxios from "../../components/authAxios";

import AddIcon from '@mui/icons-material/Add';
import { Fab, IconButton } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { VisibilityOutlined, PrintSharp } from "@mui/icons-material";

import { Card, CardContent } from "@mui/material";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive'

import { format } from 'date-fns';


import EllipsisMenu from "../../components/EllipsisMenu";


// const TransactionList = ({module, transactions, fetchTransactions, handlePageChange, page, pagecount}) => {
const TransactionList = ({module, transactions, order, handlePageChange, page, pagecount, setIsModalOpen}) => {
    const navigate = useNavigate()

    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const [showAccount, setShowAccount] = useState(true)
    const [showDescription, setShowDescription] = useState(false)
    const [showQuantity, setShowQuantity] = useState(false)

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    // const threeSubMenu = [
    //     {
    //         id: 1,
    //         menu: "View",
    //         url: "/dashboard/transaction/",

    //     }, 
    // ];

    const menuItems = (transaction) => {
        const baseItems = []

        // console.log("Transaction: ", transaction.reference)
        // console.log("Transaction: ", transaction.reference +"|"+ transaction.type_code)


        let txn_id = transaction.id
        if (module !== 'ACC') {
            txn_id = transaction.transaction
        }
        baseItems.push({
            label: 'View',
            icon: <VisibilityOutlined />,
            onClick: () => {
                navigate(`/dashboard/transaction/${txn_id}`);
            }
        });

        if (transaction.type_code === "010") {
            baseItems.push({
                label: 'Print',
                icon: <PrintSharp />,
                onClick: () => {
                    // navigate(`/dashboard/receipt-document/`, {state: {transactionId: txn_id}});
                    // navigate('/dashboard/invoicereport/',{state:{reference:reference, tag:tag}});
                    navigate('/dashboard/invoicereport/',{state:{transactionId:txn_id}});
                }
            });
        }

        if (transaction.type_code === "020") {
            baseItems.push({
                label: 'Print',
                icon: <PrintSharp />,
                onClick: () => {
                    navigate(`/dashboard/receipt-document/`, {state: {transactionId: txn_id}});
                }
            });
        }
        return baseItems;
    };

    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
    };
    
 
    useEffect(()=>{
        if (module!=="ACC") {
            setShowAccount(false)
            setShowDescription(true)
        }
        if (module==="INV" ) {
            setShowQuantity(true)
        }
     },[module])



    return (
        <>

        {isMobile? 
            <>
            
            {transactions && transactions.map(transaction => ( 

            <Card className="dashboard-card" key={transaction.id}>
                
                <CardContent className="dashboard-card-content">
                    <div className="dashboard-card-title">{transaction.amount}</div>
                    <div className="dashboard-card-subtitle">{transaction.trans_type}</div>                            
                    <p>Reference: {transaction.reference}</p>
                    <p>Account: {transaction.account}</p>
                    <p>Date: {transaction.date}</p>
                    {/* <Pillchip label={booking.status_name} /> */}
                </CardContent>
                {/* <CardActions>
                    <Button size="small">Booking</Button>
                </CardActions> */}
            </Card>
            ))}

            </>

            :
            // If Device is not mobile, display data using a table
            <>
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>Reference</th>
                        <th>Date</th>
                        <th>Type</th>
                        {showAccount && 
                            <th>Account</th>
                        }
                        {showDescription && 
                            <th>Description</th>
                        }
                        {showQuantity && 
                            <th>Quantity</th>
                        }
                        <th>Amount</th>
                        <th>DR/CR</th>
                        <th></th>
                    </tr>
                </thead>

                {transactions && transactions.map(transaction => (
                    <tbody key={transaction.id}>
                        <tr>
                            <td>{transaction.reference}</td>
                            {/* <td>{transaction.date}</td> */}
                            <td>{convertDateTime(transaction.date)}</td>

                            <td>{transaction.trans_type}</td>
                            {showAccount &&
                                <td>{transaction.account_name}</td>
                            }
                            {showDescription &&
                                <td>{transaction.description}</td>
                            }
                            {showQuantity &&
                                <td>{transaction.quantity}</td>
                            }
                            {/* <td>{Number(transaction.amount).toLocaleString('en-UK', { style: 'currency', currency: client.currency_code })}</td> */}
                            {clientProfile && clientProfile.currency_code? 
                                <td>{Number(transaction.amount).toLocaleString('en-UK', { style: 'currency', currency: clientProfile.currency_code })}</td>
                                :
                                <td>{Number(transaction.amount).toLocaleString('en-UK')}</td>
                            }

                            <td>{transaction.entry_type}</td>
                            {/* {module==="ACC" &&
                                <td className='styled-table-menu'>
                                    <ThreeDotsMenu data={transaction} threeSubMenu={threeSubMenu} />
                                </td>
                            } */}

                            <td className='styled-table-menu'>
                                <EllipsisMenu items={menuItems(transaction)} />
                            </td>
        
                        </tr>
                    </tbody>
                ))}
            </table>
            </>
        }

            
        <Pagination 
            className="custom-mui-pagination"
            count={pagecount} 
            page={page} 
            onChange={handlePageChange} 
        />

        {(module==="ACC") &&
            <Link to="/dashboard/transactionnew" state={{module: module, order:order}} className="nav-link">
                <Fab className="fab" color="primary" aria-label="add">
                    <AddIcon />
                </Fab>
            </Link>
        }

        </>

    );
  };
  
export default TransactionList;